<div class="item">
  <button
    class="label"
    data-testid="oa-questionnaire-open"
    [disabled]="checkDependsOn() || action.ac_status === 'SUBMITTED'"
    (click)="openQuestionnaire()"
  >
    <img
      class="icon"
      src="../../../../../../assets/icons/questionnaire.png"
      alt=""
    />
    <span class="oa-title"
      >{{ action.action_name }}
      <img
        *ngIf="action.ac_status !== 'SUBMITTED'"
        src="../../../../../../../../assets/icons/{{
          'Tag_to_do.svg' | translate
        }}"
        alt=""
      />
    </span>
  </button>

  <div *ngIf="action.ac_status === 'SUBMITTED'" class="actions">
    <mat-icon class="success">done</mat-icon>
  </div>
  <div *ngIf="action.ac_status !== 'SUBMITTED' && checkDependsOn()" class="actions">
    <mat-icon class="info" [matTooltip]="blockedTooltip"
      >info</mat-icon
    >
  </div>
</div>
